import {
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {Subscription} from '../subscription/queries/subscription';
import {useSubscription} from './hook/useSubscription';
import './subscription.css';
import axios from '../../axios';

const SubscriptionDetail = ({setShowNav}) => {
  const {id} = useParams();
  const {findById} = useSubscription();
  const [subscription, setSubscription] = useState(undefined);
  const [recurrent, setRecurrent] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [validCoupon, setValidCoupon] = useState(true);

  useEffect(() => {
    setShowNav(true);
  }, []);

  useEffect(async () => {
    const sub = await findById(id);
    setSubscription(sub[0]);
  }, []);

  const handleGetSession = () => {
    setIsLoading(true);
    Subscription.createSubscriptionSession(subscription.id, recurrent, coupon)
      .then(res => {
        setIsLoading(false);
        window.open(res.url, '_blank');
      })
      .catch(() => setIsLoading(false));
  };

  const navigate = useNavigate();

  const handleValidateCoupon = async coupon => {
    try {
      setIsLoading(true);
      await axios.get(`promotionCode/${coupon}/check`);
      setValidCoupon(true);
      setIsLoading(false);
      return true;
    } catch (e) {
      setIsLoading(false);
      setValidCoupon(false);
      return false;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      coupon.length > 2 && handleValidateCoupon(coupon);
    }, 700);

    return () => clearTimeout(timer);
  }, [coupon]);

  return (
    <Container>
      {subscription ? (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          padding={7}>
          <Card className={'detail-card'} sx={{padding: 2}}>
            <Stack padding={1} direction={'column'} alignItems={'center'}>
              <Typography variant={'h4'} sx={{color: '#263238'}}>
                Détail de l’abonnement
              </Typography>
            </Stack>
            <Divider />
            <Stack
              direction="column"
              justifyContent="center"
              alignItems="center"
              padding={2}>
              <Typography>
                L'abonnement vous permet d'accéder aux conseils des
                professionnels de l'OHS de Lorraine et à des services pour le
                maintien à domicile (coût en supplément en fonction des
                services) ou le bien-être en établissement
              </Typography>
              <br />
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="center">
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography variant={'subtitle1'}>Abonnement</Typography>
                  <Typography>{subscription.name.text}</Typography>
                </Stack>
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography variant={'subtitle1'}>Prix</Typography>
                  <Typography>€ {subscription.price.value}</Typography>
                </Stack>
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography variant={'subtitle1'}>Début</Typography>
                  <Typography sx={{textTransform: 'capitalize'}}>
                    {moment().format('D MMMM YYYY')}
                  </Typography>
                </Stack>
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography variant={'subtitle1'}>Fin</Typography>
                  <Typography sx={{textTransform: 'capitalize'}}>
                    {moment()
                      .add(subscription.commitment.value, 'M')
                      .format('D MMMM YYYY')}
                  </Typography>
                </Stack>
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography
                    variant={'subtitle1'}
                    component="span"
                    htmlFor="recurrent">
                    Renouvellement automatique
                  </Typography>
                  <Checkbox
                    id="recurrent"
                    sx={{marginRight: '-12px'}}
                    onChange={() => setRecurrent(!recurrent)}
                    checked={recurrent}
                  />
                </Stack>
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Typography variant={'subtitle1'}>Code Promo</Typography>
                  <TextField
                    hiddenLabel
                    id="filled-hidden-label-small"
                    variant="filled"
                    size="small"
                    onChange={e => setCoupon(e.target.value)}
                    value={coupon}
                  />
                </Stack>
                {!validCoupon && (
                  <Typography
                    sx={{
                      textAlign: 'right',
                      width: '100%',
                      color: 'red',
                      fontSize: '14px',
                    }}>
                    Code Promo invalide
                  </Typography>
                )}
                <br />
                <Stack
                  sx={{width: '400px'}}
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center">
                  <Button
                    className="btn"
                    sx={{padding: '10px'}}
                    onClick={() => navigate('/user-subscription')}>
                    Annuler
                  </Button>
                  <Button
                    disabled={isLoading}
                    className="btn"
                    onClick={() => handleGetSession()}
                    sx={{padding: '10px'}}>
                    {isLoading && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                    Procéder au paiement
                  </Button>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      ) : (
        <div></div>
      )}
    </Container>
  );
};

export default SubscriptionDetail;
